<ng-content />
<div class="vds-sub-nav-toolbar-actions">
    <ng-content select="[vdsToolbarActions]" />
</div>
